module.exports = __webpack_public_path__ + "img/accountpleno.9100a73c.svg";